import type { IHttpConfig } from 'utils/http.old/httpClient.model';
import { getSignalRConnectionId } from 'utils/streaming/signalr/connection';

export default (config: IHttpConfig): IHttpConfig => {
  return {
    ...config,
    headers: {
      ...config.headers,
      'signalr-connection-id': getSignalRConnectionId()!,
    },
  };
};
